<footer>
  <div class="page-inner">
    <div class="row">
      <span>{{ 'FOOTER.APPNAME' | translate }} v{{ version }}</span>
      <span class="license">
        <mat-icon inline>copyright</mat-icon> {{ 'FOOTER.COPYRIGHT' | translate }} - {{curYear}}
      </span>
      <nav>
        <a routerLink="/misc/about">{{ 'PAGES.TITLES.ABOUT' | translate }}</a>
        <a routerLink="/misc/imprint">{{ 'FOOTER.IMPRINT' | translate }}</a>
        <a routerLink="/misc/privacy">{{ 'FOOTER.PRIVACY' | translate }}</a>
        <a routerLink="/misc/admin" *ngIf="isStaff$ | async">Admin</a>
      </nav>
      <div class="lang">
        <app-language-select [small]="true"></app-language-select>
      </div>
    </div>
    <div class="supporters" *ngIf="showSupporters$ | async">
      <app-supporters [forFooter]="true" [hostname]="hostname$ | async"></app-supporters>
    </div>
  </div>
</footer>